export default __webpack_public_path__ + "static/media/unavailable.261c5487.svg";